<template>
<div v-if="user.isAdmin">
    <div class="flex flex-wrap flex-col md:flex-row">
        <div class="w-full md:w-1/2">
            <h1 class="mt-2 mb-4 md:mb-0 font-sans text-n-gray-dark">Festivals</h1>
        </div>
        <div class="w-full md:w-1/2 md:text-right mb-5 md:mb-0">
            <router-link to="/festivals/create" class="button mb-2">Create Festival</router-link>
        </div>
    </div>

    <table class="w-full">
        <thead>
            <tr>
                <th>Name</th>
                <th>Slug</th>
                <th></th>
                <th></th>
            </tr>
        </thead>
        <festival-item
            v-for="festival in filteredFestivals"
            :key="festival.id"
            :festival="festival"></festival-item>
    </table>

        <div class="flex mt-8">
            <div class="w-1/2">
            <button class="mt-2"
                @click.stop.prevent="previous"
                :disabled="currentPage === 1"
                :class="{'opacity-50 cursor-not-allowed': currentPage === 1}">&lt;&lt; Previous</button>
            </div>

            <div class="w-1/2 text-right">
            <button class="mt-2"
                @click.stop.prevent="next"
                :disabled="currentPage === totalPages"
                :class="{'opacity-50 cursor-not-allowed': currentPage === totalPages}">Next &gt;&gt;</button>
            </div>
        </div>
</div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import FestivalItem from './FestivalItem.vue'

    export default {
        name: 'FestivalList',
        title: 'Festival List',
        components: {
            'festival-item': FestivalItem,
        },
        data: () => ({
        }),
        computed: {
            ...mapGetters({
                adminFestivals: 'adminFestivals',
                pagination: 'festivalPagination',
                user: 'user'
            }),
            filteredFestivals() {
                return this.adminFestivals
            },
            totalRecords() {
                return Object.keys(this.adminFestivals).length
            },
            currentPage() {
                return this.pagination.current_page
            },
            totalPages() {
                return this.pagination.last_page
            }
        },
        methods: {
            previous() {
                var page = this.currentPage - 1
                this.$store.dispatch('getMoreAdminFestivals', {page: page})
                window.scrollTo(0, 0);
            },
            next() {
                var page = this.currentPage + 1
                this.$store.dispatch('getMoreAdminFestivals', {page: page})
                window.scrollTo(0, 0);
            },
        },
        mounted() {
            this.$store.dispatch('getAdminFestivals')
        }
    }
</script>
